export const table = {
  empty: 'В таблице отсутствуют данные',
  empty_db: `<span class="block text-center">В таблице отсутствуют данные.</span>`,
  create_db: `Создать базу данных`,
  overview: 'Обзор',
  actions: 'Действия',
  show: 'Показать',
  records: 'записей',
  paginate_info: 'Показаны с {start} по {end} из {all} записей',
  loading: 'Пожалуйста подождите, мы загружаем данные',
  error: 'Ошибка загрузки данных',
  last_date: 'В данном разделе доступна статистика до ',
  need_select_filter: 'Для просмотра списка доступных номеров - выберите страну',

  field: {
    id: 'Идентификатор',
    name: 'Имя',
    naming: 'Название',
    title: 'Название',
    time_zone: 'Часовой пояс',
    status: 'Статус',
    type: 'Тип',
    info: 'Информация',
    created_at: 'Дата создания',
    updated_at: 'Дата изменения'
  },

  action: {
    edit: 'Редактировать',
    change: 'Изменить',
    rename: 'Переименовать',
    duplicate: 'Дублировать',
    delete: 'Удалить',
    show: 'Показать',
    hide: 'Скрыть',
    add_ip: 'Добавить IP'
  }
};
